import './OrderSummaryChip.scss';

import { PatientOrderingProduct } from '@customTypes/test-ordering';

import { getProductTestDisplayName } from '../utils/productDisplayName';

export interface OrderSummaryProductActionProps {
  disabled?: boolean;
  product: PatientOrderingProduct;
  requiredProducts?: PatientOrderingProduct[];
  onClick: () => void;
}

export const OrderSummaryRemoveProduct = ({ product, disabled, onClick }: OrderSummaryProductActionProps) => {
  const productName = getProductTestDisplayName(product);

  return (
    <button
      type='button'
      className='order-summary-chip order-summary-chip--remove'
      aria-label={`Remove ${productName} from your order`}
      title={disabled ? 'Your order needs at least one test' : undefined}
      disabled={disabled}
      onClick={onClick}
    >
      <span>{productName}</span>
      <span className='order-summary-chip__action'>Remove</span>
    </button>
  );
};

export const OrderSummaryAddProduct = (props: OrderSummaryProductActionProps) => {
  const { disabled, product, requiredProducts, onClick } = props;

  const productName = getProductTestDisplayName(product);
  let title: string | undefined;

  if (requiredProducts?.length) {
    const requiredProductNames = requiredProducts.map(getProductTestDisplayName);
    title = `Requires having ${requiredProductNames.join(' or ')} in your order`;
  }

  return (
    <button
      type='button'
      className='order-summary-chip order-summary-chip--add'
      aria-label={`Add ${productName} to your order`}
      title={title}
      disabled={disabled}
      onClick={onClick}
    >
      <span>{productName}</span>
      <span className='order-summary-chip__action'>Add</span>
    </button>
  );
};
